import * as chartFilters from 'serviceWorker/db/chartFilters';
import type { ChartFiltersId } from 'shared/domain/chartFilters/chartFiltersModel';
import type { FilterValues } from 'shared/types/analytics';

/** Saved filters of a chart; `undefined` when it has none. */
export async function getSavedChartFilters({
  chartId,
}: {
  chartId: ChartFiltersId;
}): Promise<FilterValues | undefined> {
  const saved = await chartFilters.getOne(chartId);
  return saved?.filters;
}

/** Resolves once the filters are stored. */
export async function saveChartFilters({
  chartId,
  filters,
}: {
  chartId: ChartFiltersId;
  filters: FilterValues;
}): Promise<void> {
  await chartFilters.add({ _id: chartId, filters });
}
